import styled from 'styled-components';

// Components
import { Typography } from '../../../display/Typography';
import { MainButton } from '../../../inputs/buttons/MainButton';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  padding: 1rem;
`;

export const ContainerText = styled.div`
  text-align: center;
`;

export const Text = styled(Typography)`
  text-align: center;
`;

export const Title = styled(Text)`
  font-size: 2rem;
  margin-bottom: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap; /* hasta 4 botones: reflujan centrados en breakpoints estrechos */
  width: 100%;
`;

/**
 * Botón "Pendiente de A.T". Permite que la etiqueta larga
 * ("…assistència tècnica") salte de línea en pantallas estrechas en vez de
 * desbordar horizontalmente; el botón crece en alto. No toca el MainButton
 * compartido (que mantiene white-space: nowrap por defecto).
 */
export const PendingATButton = styled(MainButton)`
  height: auto;
  min-height: ${({ theme }) => theme.sizes.buttonHeight};
  && * {
    white-space: normal;
    text-align: center;
    line-height: 1.2;
  }
  /* El MainButton compartido cambia max-width, padding y font-weight SOLO en
     :hover. Con esta etiqueta multilínea eso reflowea el texto y empuja a los
     botones vecinos (salto de layout). Congelamos la geometría y el peso en
     hover → el botón no cambia de tamaño y nada se mueve. */
  &&:hover:not(:disabled):not(:focus-visible) {
    max-width: none;
    padding: 1rem 2rem;
  }
  &&:hover:not(:disabled):not(:focus-visible) * {
    font-weight: ${({ theme }) => theme.fontWeight.regular};
  }
`;


/**
 * Botón «tancar l'ordre i les actuacions». La etiqueta es larga: hereda de
 * PendingATButton el permiso a partir línea y la geometría congelada en hover
 * (sin eso, el hover del MainButton reflowea el texto y empuja a los vecinos).
 */
export const WideButton = styled(PendingATButton)``;

/**
 * Fila «Estat: [chip]». El `ContainerText` que la envuelve centra por
 * `text-align`, que no alinea verticalmente un chip con su etiqueta — de ahí
 * el flex propio.
 */
export const StateRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  margin-top: 0.8rem;
`;

// T99: Link para abrir la orden padre en nueva pestaña
export const ViewOrderLink = styled.a`
  display: block;
  text-align: center;
  margin: 0.5rem 0;
  color: ${({ theme }) => theme.colors.primary};
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;

  &:hover {
    opacity: 0.8;
  }
`;
